// extracted by mini-css-extract-plugin
module.exports = {"className":"textDisplayL_className__kk9yP"};